// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const poliwhirl: PokeData = {
  "id": 61,
  "name": "poliwhirl",
  "height": 10,
  "weight": 200,
  "base_experience": 135,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "body-slam",
    "double-edge",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "low-kick",
    "hypnosis",
    "amnesia",
    "bubble",
    "belly-drum",
    "rain-dance",
    "mud-shot",
    "water-sport",
    "wake-up-slap",
    "earth-power",
    "mud-bomb"
  ],
  "moves": [
    "body-slam",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "mud-shot",
    "earth-power",
    "mud-bomb",
    "water-spout",
    "aqua-cutter",
    "aqua-tail",
    "aqua-jet",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 26,
    "item": null,
    "species": [
      {
        "name": "poliwag",
        "order": 65,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "poliwhirl",
        "order": 66,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 60,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "poliwrath",
        "order": 67,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "politoed",
        "order": 68,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.25,
    "speed": 90,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
